import { useCompanyStatements } from '@/hooks/useCompanyStatements';
import { useMemo } from 'react';
import { RISKS, REWARDS } from './constants';

export function useCompanyRisksRewards(canonicalURL: string) {
  const statementsQuery = useCompanyStatements({
    canonicalURL: canonicalURL,
    names: [...RISKS, ...REWARDS],
    options: {
      staleTime: 3600000,
    },
  });

  const data = useMemo(() => {
    if (statementsQuery.data === undefined) {
      return { risks: [], rewards: [] };
    }

    const risks = statementsQuery.data.statements.filter((statement) => {
      return RISKS.includes(statement.name) && statement.value === false;
    });
    const rewards = statementsQuery.data.statements.filter((statement) => {
      return REWARDS.includes(statement.name) && statement.value === true;
    });

    return { risks, rewards };
  }, [statementsQuery.data]);

  return { ...statementsQuery, data };
}
